// extracted by mini-css-extract-plugin
export default {"wrapper":"AFVta","card-transform":"TbRRV"};